import { map, Observable, switchMap } from 'rxjs';
import { Guid, isNil, isNotNil, Nillable } from '@web/utils';
import { SelectItem } from '@web/shared/ui';
import { AbstractControl } from '@angular/forms';
import { WarehouseProductDataSourceService } from '../services/warehouse-product-data-source.service';
import { WarehouseProductSelectItemsProviderService } from '../providers/warehouse-product-select-items-provider.service';
import { warehouseProductCurrentSelectItem } from './warehouse-product-current-select-item';

export const warehouseProductSelectItemsWithCurrentSelection = (options: {
  control: AbstractControl<Nillable<Guid>>;
  dataSource: WarehouseProductDataSourceService;
  selectItemsProvider: WarehouseProductSelectItemsProviderService;
  query: Nillable<string>;
}): Observable<SelectItem<Guid>[]> => {
  const { control, dataSource, selectItemsProvider, query = null } = options;

  return warehouseProductCurrentSelectItem({ control, dataSource }).pipe(
    switchMap((currentSelectItem) =>
      selectItemsProvider.fetchCollectionAsSelectItems('id', query).pipe(
        map((selectItems) => {
          if (isNil(currentSelectItem)) {
            return selectItems;
          }

          const isCurrentExists = isNotNil(
            selectItems.find((item) => item.value === currentSelectItem.value),
          );

          if (isCurrentExists) {
            return selectItems;
          }

          return [...selectItems, currentSelectItem];
        }),
      ),
    ),
  );
};
